<template>
  <div class="signin">
    <div class="signin__content">
      <VkBtn class="mb-4" @click="loginVk">
        Войти через ВКонтакте
      </VkBtn>
      <AuthDelimiter />
    </div>

    <form class="signin__form" @submit.prevent="submit">
      <div class="signin__content">
        <div class="signin__row row">
          <div class="col-12">
            <AppControl
              label="E-mail"
              class="signin__control"
              :error="getError('email')"
            >
              <AppInput
                v-model="$v.form.email.$model"
                class="signin__input"
                :invalid="isInvalid('email')"
                placeholder="Введите E-mail"
                theme="third"
                type="email"
              />
            </AppControl>
          </div>

          <div class="col-12">
            <AppControl
              label="Пароль"
              class="signin__control"
              :error="getError('password')"
            >
              <AppInput
                v-model="$v.form.password.$model"
                class="signin__input"
                :invalid="isInvalid('password')"
                placeholder="Введите пароль"
                theme="third"
                type="password"
              />
            </AppControl>
          </div>
        </div>
      </div>

      <button class="signin__recover" type="button" @click="recoverPassword">
        Забыли пароль?
      </button>

      <p class="signin__message">{{ message }}</p>

      <AppBtn
        type="submit"
        class="signin__btn"
        color="third"
        :loading="loading"
      >
        Войти
      </AppBtn>

      <template v-if="showSignup">
        <div class="signin__message mt-3">Еще не зарегестрированы?</div>

        <AppBtn
          type="button"
          class="signin__btn"
          color="third"
          @click="$emit('to-signup')"
        >
          Регистрация
        </AppBtn>
      </template>
    </form>
  </div>
</template>

<script>
import AppControl from "@/components/ui/control/AppControl.vue";
import { getValidationMessage } from "@utils/validation-messages";
import { required, email } from "vuelidate/lib/validators";
import { requestAlert } from "@/core/common/";
import { asyncModal } from "@/components/ui/modal/";
import AuthDelimiter from "./AuthDelimiter";
import VkBtn from "./VkBtn";
import { mapActions } from "vuex";
import { openModal as openPasswordRecoverModal } from "./PasswordRecover";

const defaultForm = () => ({
  email: "",
  password: ""
});

const Signin = {
  name: "Signin",

  components: {
    AppControl,
    AuthDelimiter,
    VkBtn
  },

  props: {
    showSignup: Boolean
  },

  data: () => ({
    form: defaultForm(),
    loading: false,
    message: ""
  }),

  validations: {
    form: {
      email: { required, email },
      password: { required }
    }
  },

  methods: {
    ...mapActions("auth", ["login"]),

    recoverPassword() {
      this.$modals.close(this);
      openPasswordRecoverModal();
    },

    getError(field) {
      return getValidationMessage(this.$v.form[field]);
    },

    isInvalid(field) {
      return this.$v.form[field].$error;
    },

    async loginVk() {
      try {
        const { success, message } = await this.login({ method: "vk" });

        if (success) {
          this.$modals.close(this);
        } else {
          this.message = message;
        }
      } catch {
        requestAlert();
      }
    },

    async submit() {
      if (this.loading) return;
      this.$v.$touch();
      this.message = "";
      if (this.$v.$invalid) return;
      this.loading = true;

      try {
        const { success, message } = await this.login({
          credentials: this.form
        });

        if (success) {
          this.$modals.close(this);
        } else {
          this.message = message;
        }
      } catch {
        requestAlert();
      }

      this.loading = false;
    }
  }
};

export default Signin;

export function openModal() {
  return asyncModal({
    name: "signin-modal",
    component: Signin,
    title: "Авторизация"
  });
}
</script>

<style lang="scss">
.signin {
  width: 470px;
  max-width: 100%;
  margin: 0 auto;

  &__content {
    width: 360px;
    max-width: 100%;
    margin: 0 auto 20px;

    @include breakpoint("xs-only") {
      width: 100%;
    }
  }

  &__input {
    text-transform: uppercase;
    font-size: 20px;
    height: 60px;
    font-weight: bold;
  }

  &__control {
    margin-bottom: 25px;
  }

  &__btn {
    width: 265px;
    height: 55px;
    text-transform: uppercase;
    margin: 0 auto;
    display: flex;
    font-size: 24px;
  }

  &__message {
    text-align: center;
    margin-bottom: 20px;
    height: 18px;
  }

  &__recover {
    text-align: center;
    margin: 0 auto 10px;
    display: flex;
    text-transform: uppercase;
    font-size: 24px;
    font-weight: bold;
    color: colors(text-4);
  }
}
</style>
